import { getData } from "./axios-service";
import { LaundryProductHistoryElement,  } from "@/types/laundry-product-history-element";

function modelMapper(inputHistoryElement: any): LaundryProductHistoryElement {
    return {
        productId: inputHistoryElement.productId,
        productAquaNb: inputHistoryElement.productAquaNb,
        productType: inputHistoryElement.productType,
        productMake: inputHistoryElement.productMake,
        inDate: inputHistoryElement.inDate,
        outDate: inputHistoryElement.outDate
    };
}

export function modelMapperArray(inputArray: any[]): LaundryProductHistoryElement[] {
    return inputArray.map(modelMapper);
}

export async function fetchHistoryElementsByLaundry(laundryId: string): Promise<LaundryProductHistoryElement[]> {
    const historyElements = await getData<LaundryProductHistoryElement[]>("/laundries/" + laundryId + "/product-history-elements");
    return modelMapperArray(historyElements ?? []);
}